
import { IconButton } from '@mui/material';
import hearingJoinRequestSvg from '../../../assets/images/hearing-join-request.svg';
import { StyledBadge } from './HearingCard';
import getMessage from '../../utils/getMessage';
import { useNavigate } from 'react-router';

const HearingInformationJoinRequests = ({ hearing, marginLeft = '20px' }) => {
  
  if (!(hearing.can_access_detail && hearing.active_join_requests_num > 0)) {
    return <></>
  }

  const navigate = useNavigate();

  return (
    <IconButton
      aria-label={getMessage("activeJoinRequestsNotifications")}
      style={{ marginLeft: marginLeft }}
      onClick={() =>
        navigate({
          pathname: `/${hearing.slug}/manage/hearing-join-requests`,
        })
      }
    >
      <StyledBadge
        badgeContent={hearing.active_join_requests_num}
        color="warning"
        max={99}
      >
        <img className="hearing-image" src={hearingJoinRequestSvg} />
      </StyledBadge>
    </IconButton>
  );
};

export default HearingInformationJoinRequests;
